import { tw } from 'twind';
import React from 'react';

export function BrandLogo({ src, alt }: { src: string; alt?: string | null }) {
  return (
    <div className={tw`flex items-center justify-center pt-[24px] pb-[20px] border-b border-gray-300`}>
      <img src={src} alt={alt ?? ''} style={{ maxWidth: 112, height: 'auto' }} />
    </div>
  );
}
